import requestStatus from "../../lib/constants/requestStatus"


export const API_DEFAULT = {
    id: '',
    error: '',
    status: requestStatus.INITIALIZED,
}

export const API_PRINT_DEFAULT = {
    error: '',
    status: requestStatus.INITIALIZED,
}

export const RESULTS_DEFAULT = {
    error: '',
    status: requestStatus.INITIALIZED,
    results: []
}


export const EVENT_DEFAULT = {
    _id: null,
    name: '',
    startDate:  '',
    endDate:  ''
}

export const QUESTIONNAIRE_DEFAULT = {
    _id: null,
    name: '',
    text: ''
}